import { createServiceClient } from "shared/welda/services/axiosClient";

const apiEcommerce = createServiceClient("/ecommerce");
const apiCAC = createServiceClient("/CAC");

const GetDeliveryAddresses = async (companyID) =>
  await apiCAC.get("/GetDeliveryAddresses", {
    params: { companyID },
  });

const GetArticlesPriceAndStock = async (data) =>
  await apiCAC.post("/GetArticlesPriceAndStock", data);

const addToCart = async (data) => await apiEcommerce.post("/addToCart", data);

const removeFromCart = async (data) =>
  await apiEcommerce.post("/removeFromCart", data);

const clearCart = async (data) => await apiEcommerce.post("/clearCart", data);

const setCartPickupOrDeliveryTermCode = async (data) =>
  await apiEcommerce.post("/setCartPickupOrDeliveryTermCode", data);

const getCart = async () => await apiEcommerce.get("/getCart");

const getPaymentConditions = async () =>
  await apiEcommerce.get("/getPaymentConditions");

const createCACOrder = async (data) =>
  await apiEcommerce.post("/create-cac-order", data);

const createMongoOrder = async (data) =>
  await apiEcommerce.post("/create-mongo-order", data);

const retryOrder = async (data) =>
  await apiEcommerce.post("/retry-order", data);

const initializeOrder = async (data) =>
  await apiEcommerce.post("/initialize-order", data);

const finalizeOrder = async (data) =>
  await apiEcommerce.post("/finalize-order", data);

const getMongoOrder = async (data) =>
  await apiEcommerce.post("/getMongoOrder", data);

const getFavoriteCarts = async () =>
  await apiEcommerce.get("/getFavoriteCarts");

const createFavoriteCart = async (data) =>
  await apiEcommerce.post("/createFavoriteCart", data);

const deleteFavoriteCart = async (data) =>
  await apiEcommerce.post("/deleteFavoriteCart", data);

const editFavoriteCart = async (data) =>
  await apiEcommerce.post("/editFavoriteCart", data);

const getClientOrders = async (data) =>
  await apiEcommerce.get("/orders", { params: data });

const getMarketingCartsOverview = async (params) =>
  await apiEcommerce.get("/marketing/carts-overview", { params });

const getMarketingOrdersOverview = async (params) =>
  await apiEcommerce.get("/marketing/orders-overview", { params });

const getUnprocessedClientOrders = async (data) =>
  await apiEcommerce.get("/unprocessed-client-orders", { params: data });

const getClientOrder = async ({ orderNumber }) =>
  await apiEcommerce.get(`/order/${orderNumber}`);

const cancelUnprocessedOrder = async ({ orderId }) =>
  await apiEcommerce.post("/cancel-unprocessed-order", { orderId });

const updateCartCheckoutData = async (data) =>
  await apiEcommerce.post("/updateCartCheckoutData", data);

const requestQuote = async (data) =>
  await apiEcommerce.post("/requestQuote", data);

const eCommerceService = {
  GetDeliveryAddresses,
  GetArticlesPriceAndStock,
  addToCart,
  removeFromCart,
  clearCart,
  setCartPickupOrDeliveryTermCode,
  getCart,
  createCACOrder,
  createMongoOrder,
  initializeOrder,
  finalizeOrder,
  getPaymentConditions,
  getFavoriteCarts,
  createFavoriteCart,
  deleteFavoriteCart,
  editFavoriteCart,
  getMongoOrder,
  retryOrder,
  getClientOrders,
  getMarketingCartsOverview,
  getMarketingOrdersOverview,
  getUnprocessedClientOrders,
  getClientOrder,
  cancelUnprocessedOrder,
  updateCartCheckoutData,
  requestQuote,
};

export default eCommerceService;
